// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import LoginPage from './components/Login/LoginPage';
import TesterInterface from './components/TesterInterface/TesterInterface';
import UnderConstructionDashboard from './components/ClientInterface/UnderConstructionDashboard';
import useAuth from './useAuth';
import UserJoystickSettings from './components/SettingsInterface/SettingsInterface';
import OperatorManagement from './components/OperatorManagement/OperatorManagement';
import JIG from './components/JIG/JIG';

import HistoriqueSN from './components/HistoriqueSN/HistoriqueSN'; 



// Placeholder pour le futur dashboard mouvements
const DS5MovementDashboardPlaceholder = () => (
  <div style={{
    minHeight: '100vh',
    background: '#f5f7fa',
    padding: '80px 20px',
    textAlign: 'center',
    fontFamily: 'Segoe UI, sans-serif'
  }}>
    <h1 style={{ fontSize: '3.5em', color: '#1a3c6e', marginBottom: '30px' }}>
      DS5 Movement Tracking Dashboard
    </h1>
    <p style={{ fontSize: '1.8em', color: '#666' }}>
      En cours de développement – Accès réservé à MPSI
    </p>
    <div style={{ marginTop: '60px', fontSize: '1.4em', color: '#ff9800' }}>
      Bientôt disponible
    </div>
  </div>
);

// Protection générale : tout utilisateur connecté
const ProtectedRoutes = ({ isAuthenticated, logout }) => {
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return (
    <>
      <Navbar logout={logout} />
      <Outlet />
    </>
  );
};

// Protection exclusive MPSI
const MPSIOnlyRoute = ({ children }) => {
  const username = localStorage.getItem('username');
  const userRole = localStorage.getItem('userRole');
  const isMPSI = username === 'MPSI' && userRole === 'MPSI_ADMIN';

  if (!isMPSI) {
    return <Navigate to="/app/tester-interface" replace />;
  }
  return children;
};

const App = () => {
  const { isAuthenticated, login, logout } = useAuth();

  return (
    <Router>
      <Routes>
        {/* Page de login */}
        <Route path="/" element={<LoginPage login={login} />} />

        {/* Toutes les routes protégées */}
        <Route path="/app" element={<ProtectedRoutes isAuthenticated={isAuthenticated} logout={logout} />}>
          
          {/* PAGE D'ACCUEIL PRINCIPALE → TesterInterface pour TOUT LE MONDE */}
          <Route index element={<TesterInterface />} />

          {/* Ancien dashboard → maintenant réservé à MPSI uniquement */}
          <Route
            path="client-dashboard"
            element={
              <MPSIOnlyRoute>
                <UnderConstructionDashboard />
              </MPSIOnlyRoute>
            }
          />

          {/* Dashboard mouvements → réservé à MPSI */}
          <Route
            path="ds5-movement-dashboard"
            element={
              <MPSIOnlyRoute>
                <DS5MovementDashboardPlaceholder />
              </MPSIOnlyRoute>
            }
          />

          {/* JIG → réservé à MPSI */}
          <Route
            path="jig"
            element={
              <MPSIOnlyRoute>
                <JIG />
              </MPSIOnlyRoute>
            }
          />

          {/* Historique SN → réservé à MPSI */}
          <Route
            path="historique-sn"
            element={
              <MPSIOnlyRoute>
                <HistoriqueSN />
              </MPSIOnlyRoute>
            }
          />

          {/* Routes accessibles à tous */}
          <Route path="tester-interface" element={<TesterInterface />} />
          <Route path="user-settings" element={<UserJoystickSettings />} />
          <Route path="operator-management" element={<OperatorManagement />} />
        </Route>

        {/* Toute autre URL → redirige vers login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;